var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav lg-mx flex items-center",class:{
  isMobile: _vm.isMobile()
}},[_c('div',{staticClass:"link",on:{"click":function($event){return _vm.$router.push({name: 'index'})}}},[_vm._v("首页")]),_c('div',{staticClass:"icon"},[_vm._v(" > ")]),_c('div',{staticClass:"link",on:{"click":_vm.goModulePage}},[_vm._v(_vm._s(_vm.moduleName))]),_c('div',{staticClass:"icon"},[_vm._v(" > ")]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }